import { ref, computed, onMounted, onUnmounted } from 'vue'

const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
  wide: 1200
}

export function useBreakpoint() {
  const width = ref(window.innerWidth)

  const isMobile = computed(() => width.value <= BREAKPOINTS.tablet)
  const isTablet = computed(() => width.value > BREAKPOINTS.tablet && width.value <= BREAKPOINTS.desktop)
  const isDesktop = computed(() => width.value > BREAKPOINTS.desktop)

  function onResize() {
    width.value = window.innerWidth
  }

  onMounted(() => window.addEventListener('resize', onResize))
  onUnmounted(() => window.removeEventListener('resize', onResize))

  return { width, isMobile, isTablet, isDesktop, BREAKPOINTS }
}
